import React from 'react';
import { motion } from 'framer-motion';
import { Star, XCircle } from 'lucide-react';
import { ScrollButton } from './Shared';
const stats = [{
  value: '+500',
  label: 'profes confían'
}, {
  value: '12+6',
  label: 'Tomos + Bonus'
}, {
  value: '4.9/5',
  label: 'calificación ⭐',
  isRating: true
}, {
  value: '🇦🇷',
  label: 'Argentina',
  isFlag: true
}];
const initialTestimonials = [{
  initials: 'MP',
  quote: 'Organicé todo el mes en una tarde. Nunca más llego al estudio sin saber qué dar.',
  author: 'María P., Buenos Aires',
  role: 'Profesora de Pilates en Estudio Propio'
}, {
  initials: 'CG',
  quote: 'Mis alumnos de nivel intermedio progresaron más en un mes que en los tres anteriores.',
  author: 'Claudia G., Córdoba',
  role: 'Profesora de Pilates en Academia Privada'
}, {
  initials: 'FR',
  quote: 'Antes tardaba 1 hora armando una sesión. Ahora son 5 minutos.',
  author: 'Federico R., Rosario',
  role: 'Profesor de Pilates Reformer Independiente'
}];
const painPoints = ['Llegás al estudio sin saber exactamente qué sesión vas a dar', 'Tus alumnos no progresan porque no hay un orden claro de contenidos ni una progresión real', 'Tenés grupos con niveles mezclados y no sabés cómo manejarlos sin que nadie se quede atrás', 'Cuando hay feriado o ausencia perdés la continuidad de la práctica y todo se desordena', 'No podés justificar un aumento de precio porque no tenés nada sistematizado ni documentado', 'Usás siempre los mismos ejercicios porque te quedaste sin ideas y no sabés cómo variar', 'Llegás a casa agotada mentalmente no por dar clase sino por haber tenido que improvisar', 'Nadie valora tu trabajo porque no se ve reflejado en el progreso concreto de tus alumnos'];
export const Problem = () => {
  return <>
      {/* Dark Social Proof + Testimonials Section */}
      <section className="bg-brand-charcoal py-16 sm:py-20" data-id="element-172" data-mp="3i1821r117cga">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173" data-mp="1lz4n8kal5qq3">
          {/* Stats Row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-6 mb-16 sm:mb-20" data-id="element-174" data-mp="1qxfucn9hxn4m">
            {stats.map((stat, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="text-center" data-id="element-175" data-mp="1vpqxs03g3r1x" data-mpi={i}>
                <div className={`font-serif font-bold text-white mb-2 ${stat.isFlag ? 'text-4xl sm:text-5xl' : 'text-4xl sm:text-5xl md:text-6xl'}`} data-id="element-176" data-mp="1h01jd36cdqjp">
                  {stat.value}
                </div>
                <div className="text-brand-terracotta text-sm sm:text-base font-medium flex items-center justify-center gap-1" data-id="element-177" data-mp="2sd3yruwpga2a">
                  {stat.isRating ? <>
                      calificación{' '}
                      <Star className="text-brand-gold fill-current inline" size={16} data-id="element-178" data-mp="cs45zhiyg548" />
                    </> : stat.label}
                </div>
              </motion.div>)}
          </div>

          {/* Initial Testimonials */}
          <div className="grid md:grid-cols-3 gap-6" data-id="element-179" data-mp="3p5tvuvqr2mqh">
            {initialTestimonials.map((t, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white/[0.04] backdrop-blur-sm border border-white/10 rounded-2xl p-6" data-id="element-180" data-mp="3l5ti7dbh6fkh" data-mpi={i}>
                <div className="flex items-center gap-3 mb-5" data-id="element-181" data-mp="23rtv4zuzjml">
                  <div className="w-10 h-10 bg-brand-terracotta/20 text-brand-terracotta rounded-full flex items-center justify-center font-bold text-sm border border-brand-terracotta/30" data-id="element-182" data-mp="238bxoa7kv8k">
                    {t.initials}
                  </div>
                  <div className="flex gap-0.5" data-id="element-183" data-mp="3tacgmcivs5dt">
                    {[...Array(5)].map((_, j) => <Star key={j} className="text-brand-gold fill-current" size={14} data-id="element-184" data-mp="3fixu3vprlm20" data-mpi={j} />)}
                  </div>
                </div>
                <p className="text-white leading-relaxed mb-5 text-[15px]" data-id="element-185" data-mp="35l071bjn5vaz">
                  "{t.quote}"
                </p>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-186" data-mp="2qxjfg8v042j2">
                  — {t.author} | {t.role}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Pain Points */}
      <section className="py-20 bg-brand-cream" data-id="element-187" data-mp="30wqpam2j1f1f">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-188" data-mp="30tcqtowzhpz9">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-brand-sand" data-id="element-189" data-mp="2vv1ftauyd9fg">
            <div className="bg-brand-charcoal text-white p-10 text-center" data-id="element-190" data-mp="39ut0fufz5o2f">
              <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-191" data-mp="34w9dprtk4890">
                Si sos profe de Pilates, esto te va a sonar conocido:
              </h2>
            </div>

            <div className="p-8 md:p-12" data-id="element-192" data-mp="3emu7n1yacoll">
              <div className="space-y-6 mb-12" data-id="element-193" data-mp="3envue3onyzj5">
                {painPoints.map((point, i) => <motion.div key={i} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.1
              }} className="flex items-start gap-4" data-id="element-194" data-mp="3sn4y43voo168" data-mpi={i}>
                    <XCircle className="text-red-500 flex-shrink-0 mt-1" size={24} data-id="element-195" data-mp="iad5h48f220s" />
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-196" data-mp="narfgrtkvm1g">
                      <span className="font-semibold text-brand-charcoal" data-id="element-197" data-mp="s92oj0c1tsim">
                        ❌
                      </span>{' '}
                      {point}
                    </p>
                  </motion.div>)}
              </div>

              <div className="text-center" data-id="element-198" data-mp="2yxxqoiio8r6u">
                <h3 className="text-2xl font-serif font-bold text-brand-charcoal mb-8 italic" data-id="element-199" data-mp="2yyr2vz0eg8wd">
                  "¿Cuántas sesiones más vas a improvisar?"
                </h3>
                <ScrollButton className="w-full sm:w-auto bg-brand-charcoal hover:bg-black text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg transition-all transform hover:-translate-y-1" data-id="element-200" data-mp="1bc4gb60hvqe8">
                  👉 BASTA DE IMPROVISAR — QUIERO MI PILATES 360
                </ScrollButton>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
};